import {required } from "@vuelidate/validators";
const tlpemailtemplate = {
    data() {
      return { 
        tlpemailtemplateData:{  
          Tanim: null,
          Baslik: null,
          Mesaj: null,
          Kod: null,
        },  
          FormDataType:{
            Tanim:{FieldName:"Tanim",Field:"input",FieldTitle:"Tanım",FieldType:"text"}, 
            Baslik:{FieldName:"Baslik",Field:"input",FieldTitle:"Başlık",FieldType:"text"}, 
            Mesaj:{FieldName:"Mesaj",Field:"input",FieldTitle:"Mesaj",FieldType:"text"}, 
            Kod:{FieldName:"Kod",Field:"input",FieldTitle:"Kod",FieldType:"text"}, 
          }  
      } 
    },
    validations:{ 
      FormData: {
        Tanim: { required },  
          Baslik: { required }, 
          Mesaj: { required }, 
          Kod: { required },  
      } 
  },
}
export default tlpemailtemplate